import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@nike/podium';
/**
 * StyleOverviewContent - Style-specific overview for EntitySidebar
 *
 * TODO: Implement style overview rendering
 * - Style-level fields
 *
 * Note: ImageGallery is rendered by parent EntitySidebar component.
 */
function StyleOverviewContent({ style }) {
    return (_jsxs("div", { className: "space-y-4", children: [_jsxs(Text, { children: ["Style detail view will be implemented in a future update. Style:", ' ', style.styleNumber] }), _jsx("pre", { className: "text-xs bg-gray-100 p-4 rounded overflow-auto max-h-96", children: JSON.stringify(style, null, 2) })] }));
}
export default StyleOverviewContent;
